import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">精彩视频</h2>
          <p className="text-sm text-foreground-500">编辑精选热门视频，点击即可播放</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <article key={item.title} className="rounded-xl overflow-hidden bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group">
              <div className="aspect-video overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>{item.views}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}